(function (){
    let personaliserForm = document.querySelector("form.personaliser-form");
    let backOfficeProductId = personaliserForm?.getAttribute("data-bm-product-id");

    // Bit of a dirty way of handling this, but saves needing to update the API
    // TODO: Update the API to return the original price without personalisation cost.
    const PERSONALISATION_COST = 1.50;

    async function calculateSavingsPercentage(comparedPrice) {
        let productDetailsJSON = await window.ProductDetails.getProductDetails(backOfficeProductId);
        let pricingJSON = await window.ProductDetails.getPricing(backOfficeProductId, productDetailsJSON);

        const originalPrice = pricingJSON[7].printed - PERSONALISATION_COST;

        // Calculation: price of multiple divided by price of one, fixed to 0 decimal points. Removed from 100 otherwise
        // would be save 90% instead of save 10%.
        return (100 - ((comparedPrice - PERSONALISATION_COST) / originalPrice) * 100).toFixed(0);
    }

    document.addEventListener("DOMContentLoaded", async function () {
        let productDetailsJSON = await window.ProductDetails.getProductDetails(backOfficeProductId);
        let pricingJSON = await window.ProductDetails.getPricing(backOfficeProductId, productDetailsJSON);

        if (pricingJSON) {
            // Set the quantity values for each band
            const quantity1 = document.querySelector('.quantity-1');
            if (quantity1) {
                quantity1.innerHTML = pricingJSON[7]?.title;
            }
            const quantity2 = document.querySelector('.quantity-2');
            if (quantity2) {
                quantity2.innerHTML = pricingJSON[6]?.title;
            }
            const quantity4 = document.querySelector('.quantity-4');
            if (quantity4) {
                quantity4.innerHTML = pricingJSON[5]?.title;
            }
            const quantity10 = document.querySelector('.quantity-10');
            if (quantity10) {
                quantity10.innerHTML = pricingJSON[4]?.title;
            }
            const quantity50 = document.querySelector('.quantity-50');
            if (quantity50) {
                quantity50.innerHTML = pricingJSON[3]?.title;
            }
            const quantity100 = document.querySelector('.quantity-100');
            if (quantity100) {
                quantity100.innerHTML = pricingJSON[2]?.title;
            }
            const quantity250 = document.querySelector('.quantity-250');
            if (quantity250) {
                quantity250.innerHTML = pricingJSON[1]?.title;
            }
            const quantity500 = document.querySelector('.quantity-500');
            if (quantity500) {
                quantity500.innerHTML = pricingJSON[0]?.title;
            }

            // Set the price values for each band
            const price1 = document.querySelector('.price-1');
            if (price1 && currencyFormat && pricingJSON[7].printed && pricingJSON[7].printed > 0) {
                price1.innerHTML = currencyFormat + (pricingJSON[7]?.printed - PERSONALISATION_COST).toFixed(2);
            }
            const price2 = document.querySelector('.price-2');
            if (price2 && currencyFormat && pricingJSON[6].printed && pricingJSON[6].printed > 0) {
                price2.innerHTML = currencyFormat + (pricingJSON[6]?.printed - PERSONALISATION_COST).toFixed(2);
            }
            const price4 = document.querySelector('.price-4');
            if (price4 && currencyFormat && pricingJSON[5].printed && pricingJSON[5].printed > 0) {
                price4.innerHTML = currencyFormat + (pricingJSON[5]?.printed - PERSONALISATION_COST).toFixed(2);
            }
            const price10 = document.querySelector('.price-10');
            if (price10 && currencyFormat && pricingJSON[4].printed && pricingJSON[4].printed > 0) {
                price10.innerHTML = currencyFormat + (pricingJSON[4]?.printed - PERSONALISATION_COST).toFixed(2);
            }
            const price50 = document.querySelector('.price-50');
            if (price50 && currencyFormat && pricingJSON[3].printed && pricingJSON[3].printed > 0) {
                price50.innerHTML = currencyFormat + (pricingJSON[3]?.printed - PERSONALISATION_COST).toFixed(2);
            }
            const price100 = document.querySelector('.price-100');
            if (price100 && currencyFormat && pricingJSON[2].printed && pricingJSON[2].printed > 0) {
                price100.innerHTML = currencyFormat + (pricingJSON[2]?.printed - PERSONALISATION_COST).toFixed(2);
            }
            const price250 = document.querySelector('.price-250');
            if (price250 && currencyFormat && pricingJSON[1].printed && pricingJSON[1].printed > 0) {
                price250.innerHTML = currencyFormat + (pricingJSON[1]?.printed - PERSONALISATION_COST).toFixed(2);
            } else {
                if (price250 && currencyFormat && pricingJSON[2].printed && pricingJSON[2].printed > 0) {
                    // If the value is less than 0, fall back to the previous value
                    price250.innerHTML = currencyFormat + (pricingJSON[2]?.printed - PERSONALISATION_COST).toFixed(2);
                }
            }

            // Set the percentage values for each band
            // Ignoring the first one as that is the original price and does not have savings
            const savings2 = document.querySelector('.savings-2');
            if (savings2) {
                savings2.innerHTML = await calculateSavingsPercentage(pricingJSON[6]?.printed - 1.50);
            }
            const savings4 = document.querySelector('.savings-4');
            if (savings4) {
                savings4.innerHTML = await calculateSavingsPercentage(pricingJSON[5]?.printed - 1.50);
            }
            const savings10 = document.querySelector('.savings-10');
            if (savings10) {
                savings10.innerHTML = await calculateSavingsPercentage(pricingJSON[4]?.printed - 1.50);
            }
            const savings50 = document.querySelector('.savings-50');
            if (savings50) {
                savings50.innerHTML = await calculateSavingsPercentage(pricingJSON[3]?.printed - 1.50);
            }
            const savings100 = document.querySelector('.savings-100');
            if (savings100) {
                savings100.innerHTML = await calculateSavingsPercentage(pricingJSON[2]?.printed - 1.50);
            }
            const savings250 = document.querySelector('.savings-250');
            if (savings250) {
                if (await calculateSavingsPercentage(pricingJSON[1].printed - 1.50) < 100) {
                    savings250.innerHTML = await calculateSavingsPercentage(pricingJSON[1]?.printed - 1.50);
                } else {
                    // If the savings is greater than 100%, fall back to the previous value
                    savings250.innerHTML = await calculateSavingsPercentage(pricingJSON[2]?.printed - 1.50);
                }
            }
        }
    });
})();